module.exports = __webpack_public_path__ + "media/images/icon/button-urgent-jobs-e4d20f11002b314d3ca66e25f5424bcb.png";